import * as css from "./ScheduledDemoGroup.module.css"

function ScheduledDemoGroup({ title, children }) {
  return (
    <div className={css.group}>
      <div className={css.title}>{title}</div>
      <div className={css.grid}>{children}</div>
    </div>
  )
}

export default ScheduledDemoGroup
